<template>
  <v-dialog
    v-model="dialog"
    persistent
    max-width="600px"
    :fullscreen="$vuetify.breakpoint.xsOnly"
  >
    <v-card>
      <v-toolbar>
        <v-toolbar-title>{{ $route.meta.nameDrawer }}</v-toolbar-title>
        <v-spacer></v-spacer>
        <v-btn icon @click="closeDialog()"><v-icon>mdi-close</v-icon></v-btn>
      </v-toolbar>
      <v-container class="d-flex justify-center">
        <v-form ref="form" v-model="valid" lazy-validation>
          <!-- Nome Completo -->
          <v-card-text style="width: 400px;">
            <v-text-field
              v-model="collaboratorName"
              :rules="required"
              :label="$t('fullName')"
              outlined
              required
              class="my-6"
              dense
              autofocus
            >
            </v-text-field>
            <v-text-field
              v-model="collaboratorLogin"
              :rules="collaboratorLoginRules"
              :label="$t('login')"
              outlined
              required
              class="mb-6"
              dense
            ></v-text-field>
            <!-- Password to EditUser -->
            <v-text-field
              v-model="collaboratorPassword"
              :label="$t('changePassword')"
              type="password"
              v-if="id_usuario"
              outlined
              required
              dense
              :counter="8"
              maxlength="8"
              autocapitalize="off"
            ></v-text-field>

            <div v-if="!id_usuario">
              <v-text-field
                :class="[
                  !collaboratorPassword || show
                    ? 'show-password'
                    : 'hide-password',
                ]"
                :label="$t('password')"
                v-model="collaboratorPassword"
                :rules="passwordRules"
                required
                clearable
                outlined
                dense
                :append-icon="show ? 'mdi-eye' : 'mdi-eye-off'"
                @click:append="show = !show"
                type="text"
                :counter="8"
                maxlength="8"
                autocapitalize="off"
              ></v-text-field>

              <v-text-field
                :class="[
                  !confirmPassword || show1 ? 'show-password' : 'hide-password',
                ]"
                :label="$t('confirmPassword')"
                v-model="confirmPassword"
                :rules="passMatch"
                required
                clearable
                outlined
                dense
                :append-icon="show1 ? 'mdi-eye' : 'mdi-eye-off'"
                @click:append="show1 = !show1"
                type="text"
                :counter="8"
                maxlength="8"
                autocapitalize="off"
              ></v-text-field>
            </div>

            <v-autocomplete
              v-model="group"
              :items="groups"
              :label="$t('groups')"
              item-value="id"
              item-text="descricao"
              class="mt-6"
              outlined
              dense
              clearable
              :rules="required"
              required
            ></v-autocomplete>
          </v-card-text>
        </v-form>
      </v-container>
      <v-divider />
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn
          :disabled="!valid || loading"
          :loading="loading"
          class="info my-1"
          @click="updateCollaborator()"
        >
          {{ $t("toSave") }}
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { validate } from "@/util/validate";
export default {
  name: "views-backoffice-users-editUser",
  data: () => ({
    collaboratorName: "",
    collaboratorLogin: "",
    collaboratorPassword: "",
    confirmPassword: "",
    showPassword: true,
    group: "",
    groups: [],

    // Edit
    id_usuario: "",
    endpoint: "",

    // Validate
    valid: false,
    show: false,
    show1: false,
    required: [(v) => !!v || "Campo obrigatório"],
    // collaborator name rules
    collaboratorLoginRules: [
      validate.required,
      validate.usernameMax,
      validate.usernameAz09,
      validate.max,
    ],
    // password rules
    passwordRules: [
      validate.required,
      validate.passRule,
      validate.passCaracter,
      validate.max,
    ],
    // Transforma type password em type Text
    fieldTypes: {
      password: "text",
    },
    loading: false,
  }),

  computed: {
    dialog() {
      return this.$store.state.showDialog;
    },
    // Repeat password
    passMatch() {
      const rules = [];
      let required = this.$t("requiredInput");
      let repeatPassWord = this.$t("repeatThePassword");
      // Required
      if (this.confirmPassword) {
        const rule = (v) => !!v || required;
        rules.push(rule);
      }

      // Confirm Password
      if (this.collaboratorPassword) {
        const rule = (v) =>
          (!!v && v) === this.collaboratorPassword || repeatPassWord;
        rules.push(rule);
      }

      return rules;
    },

    status() {
      return this.$store.state.filters.selectStatus.status;
    },
  },

  mounted() {
    // this.listPermissions();
    this.listGroups();
    this.id_usuario = this.$route.query.id_usuario;
    // Edição
    if (!this.id_usuario) {
      this.endpoint = "administrator/colab/addUser";
      return;
    }
    this.group = this.$route.query.group_id;
    this.showPassword = true;
    // Setup do Endpoint Edit
    this.endpoint = "administrator/colab/editUser";
    // Consumo - Get User
    const body = {
      id_user: this.id_usuario,
      status: this.status,
    };
    this.$axios
      .post("administrator/colab/getUser", this.$formdata(body))
      .then((response) => {
        if (response.status === 200) {
          this.collaboratorName = response.data.dados.nome;
          this.collaboratorLogin = response.data.dados.login;
        }
      });
  },

  watch: {
    dialog(val) {
      !val && this.$router.go(-1);
    },
  },

  methods: {
    listGroups() {
      this.$axios
        .post("administrator/colab/listGroups")
        .then((response) => {
          if (response.status === 200) {
            this.groups = response.data.dados;
          }
        })
        .catch((error) => {
          console.log(error);
        });
    },

    updateCollaborator() {
      // Validated
      if (!this.$refs.form.validate()) {
        return;
      }
      this.loading = true;
      let body = {
        name: this.collaboratorName,
        login: this.collaboratorLogin,
        password: this.collaboratorPassword ? this.collaboratorPassword : "",
        group: this.group,
      };

      if (this.id_usuario) {
        body.id = this.id_usuario;
        body.status = this.status;
      } else {
        body.password = this.collaboratorPassword;
      }

      for (let i = 0; i < this.group.length; i++) {
        var obj = this.group[i];
        for (const [key, value] of Object.entries(obj)) {
          if (key == "groups") {
            body[`${key}[${i}]`] = value;
          }
        }
      }

      this.$axios
        .post(this.endpoint, this.$formdata(body))
        .then((response) => {
          if (response.status === 200) {
            this.$store.commit("setRefresh", true);
            this.$store.commit("setFeedbackSnack", {
              msg: response.data.messages,
              color: "success",
            });

            this.closeDialog();
          }
        })
        .finally(() => {
          this.loading = false;
        });
    },

    closeDialog() {
      this.$store.commit("showDialog", false);
    },
  },
};
</script>
